import moment from 'moment';

import * as persistent from './persistent';
import { removeUserLocation } from './geolocation';

import Logger from './logging';

const SAVED_URL = "pil_data";
const PORTAL_TOKEN = "portalToken";
const PORTAL_EMAIL = "portalEmail";

export const setLogin = (value) => {
	persistent.setPersistentValue(PORTAL_EMAIL, value);
};

export const getLogin = () => {
	return persistent.getPersistentValue(PORTAL_EMAIL);
};

export const setToken = (value) => {
	persistent.setPersistentValue(PORTAL_TOKEN, value);
};

export const getToken = () => {
	return persistent.getPersistentValue(PORTAL_TOKEN);
};

export const setSavedUrl = (value) => {
	let savedUrlData = {
		url: value,
		endDate: moment().add(24, 'hours').format()
	};
	persistent.setPersistentValue(SAVED_URL, btoa(JSON.stringify(savedUrlData)));
};

export const getSavedUrl = () => {
	const savedUrl = persistent.getPersistentValue(SAVED_URL);
	try {
		const urlData = atob(savedUrl);
		const urlJSON = JSON.parse(urlData);
		if (urlJSON) {
			let savedUrlEndDate = urlJSON.endDate;
			if (savedUrlEndDate) {
				if (moment().isAfter(moment(savedUrlEndDate))) {
					removeThirdPartyUrl();
				}
				else {
					return urlJSON.url;
				}
			}
		}
		return null;
	}
	catch(e) {
		removeSavedUrl();
		return null;
	}
};

export const removeSavedUrl = () => {
	persistent.removePersistentValue(SAVED_URL);
};

export const checkThirdPartyEndDate = () => {
	let thirdPartyUrlEndDate = getThirdPartyUrlEndDate();
	let thirdPartyUrl = getThirdPartyUrl();

	if (thirdPartyUrlEndDate && thirdPartyUrl) {
		let thirdPartyEndDate = moment(thirdPartyUrlEndDate);
		let today = moment();
		if (today.isAfter(thirdPartyEndDate)) {
			removeThirdPartyUrl();
		}
	}
};

export const setThirdPartyUrl = (value) => {
	let today = moment();
	let thirdPartyEndDate = today.add(24, 'hours');
	persistent.setPersistentValue('thirdPartyEndDate', thirdPartyEndDate.format());
	persistent.setPersistentValue('thirdPartyUrl', value);
};

export const getThirdPartyUrl = () => {
	return persistent.getPersistentValue('thirdPartyUrl');
};

export const getThirdPartyUrlEndDate = () => {
	return persistent.getPersistentValue('thirdPartyEndDate');
};

export const removeThirdPartyUrl = () => {
	let thirdPartyUrl = getThirdPartyUrl();
	let thirdPartyEndDate = getThirdPartyUrlEndDate();
	if (thirdPartyUrl) persistent.removePersistentValue('thirdPartyUrl');
	if (thirdPartyEndDate) persistent.removePersistentValue('thirdPartyEndDate');
};

export const logout = (callback) => {
	persistent.removePersistentValue(PORTAL_TOKEN);
	removeUserLocation();
	removeThirdPartyUrl();

	if (callback) {
		callback();
	}
};

export const deletePortalEmail = (callback) => {
	persistent.removePersistentValue(PORTAL_EMAIL);
	if (callback) {
		callback();
	}
};

export const isAuthenticated = () => {
	return !!getToken();
};

export const isEUUser = () => {
	const is_eu = persistent.getSessionValue("is_eu");
	return ((typeof is_eu === "string") && (is_eu === 'true')) || is_eu === true;
};

export const canAccessPublic = () => {
	Logger.log("auth.js", "canAccessPublic()", isEUUser(), !isEUUser());
	// return !isEUUser();
	return true;
};

export const canAccessPrivate = () => {
	Logger.log("auth.js", "canAccessPrivate()", isAuthenticated(), isAuthenticated() === true);
	return isAuthenticated() === true; // && !isEUUser();
};

export const isValidEmail = (email) => {
	let validEmailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

	// validEmailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	validEmailPattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

	return validEmailPattern.test(email);
};


// WEBPACK FOOTER //
// ./src/functions/auth.js